import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgPlaneSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#plane-search_svg__a)">
      <circle cx={7} cy={8} r={5.5} stroke="#17181A" />
      <path
        fill="#17181A"
        d="m15 15.293-.707.707-3.949-3.949.707-.707zM9.097 6.6a.5.5 0 1 0-.707-.706l.707.707ZM5.049 8.839l-.353-.353-.707.707.353.353.707-.707Zm.396 1.81.353.354.708-.707-.354-.354-.707.707ZM8.39 5.894 4.894 9.39l.707.707L9.097 6.6l-.707-.707ZM5.6 9.39l-.55-.552-.708.707.552.552.707-.707Zm-.706.707.55.551.708-.707-.551-.551-.707.707Z"
      />
      <path
        d="m7.254 7.689.478-.147a.5.5 0 0 0-.338-.333l-.14.48Zm-2.48-1.245-.48-.14-.28.96.48.14.28-.96Zm2.824 4.069.147.478.956-.293-.147-.479-.956.294Zm-.204-3.304-2.62-.765-.28.96 2.62.765.28-.96Zm-.618.626.822 2.678.956-.293-.822-2.678-.956.293Z"
        fill="#17181A"
      />
    </g>
    <defs>
      <clipPath id="plane-search_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgPlaneSearch);
export default Memo;
